/**
 * Qatar History Persona - Quiz Definitions (Arabic)
 *
 * Arabic translation of quizzes.js - structure and logic values are identical.
 */

export const moduleQuizzes = {
  'quiz-geography': {
    intro: "هيا نختبر فهمك لجغرافية قطر. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "لماذا كانت الزراعة صعبة في قطر المبكرة؟",
        options: [
          "قيادة ضعيفة",
          "مناخ بارد",
          "نقص الأمطار والمياه العذبة",
          "اكتظاظ سكاني"
        ],
        correctIndex: 2,
        explanation: "جعلت البيئة الصحراوية في قطر الزراعة صعبة، مما اضطر الناس للاعتماد على البحر."
      },
      {
        question: "كيف ساعد موقع قطر في تطورها المبكر؟",
        options: [
          "كان لديها غابات",
          "كان لديها أنهار كبيرة",
          "ربطت قطر بطرق التجارة البحرية",
          "كان لديها وديان خصبة"
        ],
        correctIndex: 2,
        explanation: "ربط موقع قطر شبه الجزيري بالطرق التجارية البحرية المهمة عبر الخليج العربي."
      }
    ],
    passingScore: 1,
    completionMessage: "عمل رائع! أنت تفهم جغرافية قطر. هيا نستمر في التعرف على صيد اللؤلؤ."
  },

  'quiz-pearl-diving': {
    intro: "هيا نختبر معرفتك باقتصاد صيد اللؤلؤ. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "لماذا كانت اللآلئ مهمة لاقتصاد قطر؟",
        options: [
          "كانت تُستخدم كغذاء",
          "كانت للزينة فقط",
          "كانت تُباع دولياً للدخل",
          "كانت تُستخدم كأدوات"
        ],
        correctIndex: 2,
        explanation: "كانت اللآلئ الصادر الرئيسي لقطر، تُباع لتجار من الهند وأوروبا مقابل دخل كبير."
      },
      {
        question: "ما الذي جعل صيد اللؤلؤ خطراً؟",
        options: [
          "الماء البارد",
          "العواصف فقط",
          "الغوص الطويل بحبس النفس دون معدات",
          "أشعة الشمس القوية"
        ],
        correctIndex: 2,
        explanation: "كان على غواصي اللؤلؤ حبس أنفسهم لفترات طويلة أثناء الغوص العميق دون معدات أوكسجين."
      }
    ],
    passingScore: 1,
    completionMessage: "ممتاز! أنت تفهم حقبة صيد اللؤلؤ. هيا نتعلم عن القيادة."
  },

  'quiz-leadership': {
    intro: "هيا نختبر فهمك للحكم والاستقرار. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "ما الدور الذي لعبته عائلة آل ثاني في قطر؟",
        options: [
          "قيادة صيد اللؤلؤ",
          "التحكم في التجارة الأوروبية",
          "توفير القيادة السياسية طويلة الأمد",
          "الحكم من بريطانيا"
        ],
        correctIndex: 2,
        explanation: "برزت عائلة آل ثاني كالعائلة الحاكمة لقطر، وحدت القبائل وحافظت على الاستقرار."
      },
      {
        question: "لماذا قبلت قطر الحماية البريطانية؟",
        options: [
          "لتصبح مستعمرة",
          "لتحسين الزراعة",
          "لحماية التجارة والأمن",
          "لزيادة عدد السكان"
        ],
        correctIndex: 2,
        explanation: "ساعدت الحماية البريطانية في حماية طرق التجارة القطرية مع السماح بالحكم المحلي."
      }
    ],
    passingScore: 1,
    completionMessage: "أحسنت! أنت تفهم تاريخ حكم قطر. هيا نستكشف الاستقلال."
  },

  'quiz-independence': {
    intro: "هيا نختبر معرفتك باستقلال قطر. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "ماذا تعني السيادة؟",
        options: [
          "النجاح الاقتصادي",
          "القوة العسكرية",
          "السيطرة الكاملة على القرارات الوطنية",
          "التأثير الثقافي"
        ],
        correctIndex: 2,
        explanation: "السيادة تعني أن الأمة لديها سيطرة كاملة على حكومتها وعلاقاتها الخارجية."
      },
      {
        question: "لماذا يعتبر عام 1971 عاماً مهماً في تاريخ قطر؟",
        options: [
          "اكتشاف النفط",
          "نهاية صيد اللؤلؤ",
          "أصبحت قطر مستقلة",
          "أول انتخابات"
        ],
        correctIndex: 2,
        explanation: "في عام 1971، أعلنت قطر استقلالها وأصبحت دولة ذات سيادة كاملة."
      }
    ],
    passingScore: 1,
    completionMessage: "عمل عظيم! أنت تفهم استقلال قطر. هيا نتعلم عن الطاقة."
  },

  'quiz-oil-gas': {
    intro: "هيا نختبر معرفتك بقطاع الطاقة في قطر. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "أي مورد كان له أكبر تأثير على تنمية قطر؟",
        options: [
          "الفحم",
          "الطاقة الشمسية",
          "الغاز الطبيعي",
          "الأخشاب"
        ],
        correctIndex: 2,
        explanation: "حوّل الغاز الطبيعي، خاصة من الحقل الشمالي، قطر إلى إحدى أغنى دول العالم."
      },
      {
        question: "كيف استخدمت قطر إيرادات الطاقة بشكل رئيسي؟",
        options: [
          "الجيش فقط",
          "المشاريع الفاخرة فقط",
          "الخدمات العامة والبنية التحتية",
          "الزراعة فقط"
        ],
        correctIndex: 2,
        explanation: "استثمرت قطر إيرادات الطاقة في البنية التحتية والتعليم والرعاية الصحية والتنمية طويلة الأمد."
      }
    ],
    passingScore: 1,
    completionMessage: "ممتاز! أنت تفهم تحول الطاقة في قطر. هيا نستكشف قطر الحديثة."
  },

  'quiz-modern-qatar': {
    intro: "هيا نختبر فهمك لقطر الحديثة. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "ما الذي يفسر أفضل النفوذ العالمي لقطر؟",
        options: [
          "حجم السكان",
          "الإنتاج الزراعي",
          "موارد الطاقة والدبلوماسية",
          "السياحة وحدها"
        ],
        correctIndex: 2,
        explanation: "يأتي نفوذ قطر من القيادة الاستراتيجية في مجال الطاقة والدبلوماسية النشطة، وليس من حجمها الصغير."
      },
      {
        question: "لماذا تحمي قطر تقاليدها أثناء التحديث؟",
        options: [
          "لتجنب التغيير",
          "لعزل البلاد",
          "للحفاظ على الهوية الوطنية",
          "للحد من التعليم"
        ],
        correctIndex: 2,
        explanation: "تحافظ قطر على التقاليد للاحتفاظ بهويتها الوطنية الفريدة مع تبني التنمية الحديثة."
      }
    ],
    passingScore: 1,
    completionMessage: "تهانينا! لقد أكملت أساسيات تاريخ قطر. أنت الآن تفهم رحلة قطر من مجتمع صيد اللؤلؤ إلى أمة عالمية حديثة."
  },
};

export const finalQuiz = {
  intro: "هذا هو التقييم النهائي. لنرى كم تعلمت عن تاريخ قطر.",
  questions: [
    {
      question: "متى حصلت قطر على الاستقلال؟",
      correctAnswer: "1971",
      keywords: ["1971", "الف وتسعمائة وواحد وسبعون"],
      topic: "الاستقلال"
    },
    {
      question: "أي عائلة تحكم قطر؟",
      correctAnswer: "آل ثاني",
      keywords: ["آل ثاني", "ثاني", "al thani", "thani"],
      topic: "القيادة"
    }
  ],
  passingScore: 1,
  completionMessage: "تهانينا! لقد أكملت أساسيات تاريخ قطر. أنت الآن تفهم كيف شكلت الجغرافيا والقيادة والموارد الطبيعية رحلة قطر نحو الدولة الحديثة."
};

const qatarHistoryQuizzes = {
  moduleQuizzes,
  finalQuiz,
};

export default qatarHistoryQuizzes;
